export default __webpack_public_path__ + "static/media/hero.ff60891f.jpg";